module.exports = __webpack_public_path__ + "img/home_top.1d3abb59.jpg";